import _ from 'underscore';
import MapConstants from 'constants/map/map';
import L from 'leaflet';
import Util from 'views/utils/LeafletMap/utils/Util';
import MapProvider from 'views/utils/LeafletMap/MapProviders/MapProvider';
import GarminDirectionService from 'views/utils/LeafletMap/MapServices/GarminDirectionService';
import HERELocationService from 'views/utils/LeafletMap/MapServices/HERELocationService';
import LeafletHere from 'leaflet_here';

var HereProvider = function(args) {
    MapProvider.apply(this, args);

    this.directionService = new GarminDirectionService({
        transitMode: args.transitMode
    });

    this.locationService = new HERELocationService({});

    this.name = Util.MapProviders.HERE;
};

HereProvider.prototype = Object.create(MapProvider.prototype);
HereProvider.prototype.constructor = HereProvider;

//SHARED METHODS
HereProvider.prototype.getTileLayer = function getTileLayer(layerType) {
    layerType = layerType ? layerType : 'road';
    return new L.tileLayer.here({
        appId: MapConstants.HereAppId,
        apiKey: MapConstants.HereApiKey,
        style: Util.HereMapTileTypeMapping[layerType.toLowerCase()]
    });
};

export default HereProvider;
